const root = "_arar1b86fdu";
const button = "_arab19meb6h";
const meta = "_aram1a99y7z";

export { button, meta, root };
import "./button.style.linaria.module.css";
//# sourceMappingURL=button.style.js.map
